import { useContext } from "react";
import {
  Box,
  Button,
  Modal,
  Fade,
  Typography,
  Divider,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import { ClienteContext } from "../../contexts/clientes-context";
import { useNavigate } from "react-router-dom";
import { useFormikContext } from "formik";

export default function AcoesCadastro() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const {
    openModal,
    setOpenModal,
    abrirModalSolicitar,
    confirmarSolicitacao,
    cancelarSolicitacao,
    solicitarCliente,
    detalhesClientes,
    constantes,
    tabValue,
    setTab,
  } = useContext(ClienteContext);

  const navigate = useNavigate();
  const { values, setFieldValue, handleChange, handleSubmit } = useFormikContext();

  const totalTabs = 7;
  const lastTabIndex = totalTabs - 1;
  const canGoBack = tabValue > 0;
  const handlePreviousStep = () => {
    if (canGoBack) {
      setTab(tabValue - 1);
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  };

  return (
    <>
      <Box
        sx={{
          position: "fixed",
          bottom: 0,
          left: 0,
          right: 0,
          display: "grid",
          gridTemplateColumns: isMobile ? "1fr 1fr" : "1fr 1fr 1fr 1fr",
          gap: { xs: 0.5, sm: 1 },
          padding: { xs: 1, sm: 2 },
          backgroundColor: "white",
          boxShadow: "0px -2px 10px rgba(0, 0, 0, 0.1)",
          boxSizing: "border-box",
          overflow: "hidden",
          maxWidth: "100%",
        }}
      >
        {!isMobile && (
          <>
            {/* Desktop: Etapa Anterior */}
            {canGoBack && (
              <Button
                onClick={handlePreviousStep}
                sx={{
                  background: "#6c757d",
                  color: "white",
                  "&:hover": { background: "#5a6268" },
                }}
              >
                ← Etapa Anterior
              </Button>
            )}

          </>
        )}

        {/* Cancelar */}
        <Button
          onClick={() => {
            navigate(-1);
          }}
          sx={{ background: "crimson", color: "white" }}
        >
          {constantes.Cancelar}
        </Button>

        {/* Cadastrar/Solicitar */}
        {solicitarCliente ? (
          <Button
            onClick={abrirModalSolicitar}
            sx={{ background: "#f0ad4e", color: "white" }}
          >
            {constantes.Solicitar}
          </Button>
        ) : (
          <Button type="submit" sx={{ background: "#0D9B86", color: "white" }}>
            {constantes.Cadastrar}
          </Button>
        )}
      </Box>

      {solicitarCliente && (
        <Modal
          open={openModal}
          onClose={() => setOpenModal(false)}
          closeAfterTransition
        >
          <Fade in={openModal}>
            <Box
              sx={{
                backgroundColor: "white",
                boxShadow: 24,
                p: { xs: 1.5, sm: 2, md: 3 },
                width: { xs: "90%", sm: "80%", md: "60%", lg: "40%" },
                maxHeight: "80vh",
                overflow: "auto",
                margin: "auto",
                marginTop: { xs: "10%", sm: "15%", md: "10%", lg: "15%" },
              }}
            >
              <Typography variant="h6" gutterBottom>
                {constantes.SolicitarCliente}
              </Typography>
              <Divider sx={{ background: "black" }} />
              <Box>
                <textarea
                  name="solicitarAlteracoesClientes"
                  value={values.solicitarAlteracoesClientes}
                  onChange={handleChange}
                  style={{
                    width: "100%",
                    margin: "1rem 0",
                    borderRadius: 10,
                    border: "1px solid grey",
                    padding: "0.5rem",
                  }}
                  rows={3}
                  placeholder="Faça sua solicitação..."
                />
              </Box>

              <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                <Button
                  type="submit"
                  onClick={cancelarSolicitacao}
                  sx={{ background: "crimson", color: "white" }}
                >
                  {constantes.Cancelar}
                </Button>
                <Button
                  onClick={() => {
                    setFieldValue(
                      "solicitarAlteracoesClientes",
                      values.solicitarAlteracoesClientes
                    );
                    confirmarSolicitacao(
                      detalhesClientes.Id,
                      values.solicitarAlteracoesClientes
                    );
                  }}
                  sx={{ background: "#0D9B86", color: "white" }}
                >
                  {constantes.Confirmar}
                </Button>
              </Box>
            </Box>
          </Fade>
        </Modal>
      )}
    </>
  );
}
